import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Add,
  BasicModal,
  Button,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import React, { useState } from 'react';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import {
  SimpleSearch,
  Typography,
} from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { getTextWithToolTip } from '../../../core-utils/helper-utils/riskPatientDetailsHelper';
import EditIconSvg from '../../atoms/Icons/EditIconSvg';
import { AddCustomParameter } from '../../molecules/AddCustomParameter';

export interface AddNewAndSubParameterProps {
  title: string;
  topicName: string;
  topicDescription: string;
  cancelButtonLabel: string;
  saveButtonLabel: string;
  subTitle?: string;
  subBody?: React.ReactNode;
  searchText?: string;
   
  onSearchChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleClose: () => void;
  customParams?: { name: string; description: string }[];
  setCustomParams?: React.Dispatch<
    React.SetStateAction<{ id: string; name: string; description: string }[]>
  >;
   
  onTopicSave?: (topic: {
    name: string;
    description: string;
    selectedTerms: { name: string; description: string }[];
  }) => void;
  isConfirmDisabled: boolean;
  selectedTerms: { name: string; description: string }[];
  isAddCustom?: boolean;
  setIsAddCustom?: React.Dispatch<React.SetStateAction<boolean>>;
}

const useStyles = makeStyles()({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
  sectionContainer: {
    padding: '16px',
    width: '100%',
    borderRadius: '8px',
    backgroundColor: `${patientAccessTheme.palette.grey[100]}`,
  },
  sectionContainer2: {
    display: 'flex',
    gap: '12px',
  },
  section2: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  controlsContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
  },
  addCustomConatiner: {},
  subCard: {},
  section2Inner: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    width: '100%',
  },
});

const AddNewAndSubParameter: React.FC<AddNewAndSubParameterProps> = ({
  title,
  cancelButtonLabel,
  saveButtonLabel,
  subTitle,
  subBody,
  searchText,
  onSearchChange,
  topicName,
  topicDescription,
  handleClose,
  setCustomParams,
  // finalSave,
  onTopicSave,
  isConfirmDisabled,
  selectedTerms,
  isAddCustom,
  setIsAddCustom,
}) => {
  const { classes } = useStyles();
  const [localTopicName, setLocalTopicName] = useState<string>(topicName);
  const [localTopicDescription, setLocalTopicDescription] = useState<string>(
    topicDescription,
  );
  const [isActive, setIsActive] = useState<boolean>(false);
  const showEditIcon = !!topicName && !isActive;
  const isEditing = !topicName || isActive;
  return (
    <BasicModal
      open={true}
      title={title}
      rootStyles={{
        width: '625px',
        height: '70vh',
        border: 'none',
        boxShadow: 'none',
        outline: 'none',
        borderRadius: '8px',
        overflowY: 'scroll',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
      }}
      isConfirmDisabled={isConfirmDisabled}
      cancelButtonLabel={cancelButtonLabel}
      confirmButtonLabel={saveButtonLabel}
      handleCancel={handleClose}
      handleConfirm={() => {
        // const topicData = {
        //   name: localTopicName,
        //   description: localTopicDescription,
        // };

        onTopicSave?.({
          name: localTopicName,
          description: localTopicDescription,
          selectedTerms,
        });
        //  selectedTerms={selectedCustomParams}
        handleClose(); // optionally keep this here
      }}
      handleClose={handleClose}
      body={
        <Grid className={classes.mainContainer}>
          <Grid
            className={`${classes.sectionContainer} ${
              showEditIcon ? classes.sectionContainer2 : ''
            }`}
          >
            <Grid>
              <ReportCreateNewLabelField
                label="Name"
                width="100%"
                component={
                  isEditing ? (
                    <TextField
                      value={localTopicName}
                      fullWidth
                      height="36px"
                      onChange={(e: any) => setLocalTopicName(e.target.value)}
                      placeholder="Enter Name"
                    />
                  ) : (
                    <Typography
                      fontSize="14px"
                      textColor={`${patientAccessTheme.palette.text.highemphasis}`}
                    >
                      {topicName}
                    </Typography>
                  )
                }
              />
              <ReportCreateNewLabelField
                label="Description (Optional)"
                width="100%"
                component={
                  isEditing ? (
                    <TextField
                      value={localTopicDescription}
                      fullWidth
                      height="36px"
                      onChange={(e: any) =>
                        setLocalTopicDescription(e.target.value)
                      }
                      placeholder="Enter Topic Description"
                    />
                  ) : (
                    <Typography
                      fontSize="14px"
                      textColor={`${patientAccessTheme.palette.text.highemphasis}`}
                    >
                      {topicDescription.length > 130
                        ? getTextWithToolTip(topicDescription, 130)
                        : topicDescription}
                    </Typography>
                  )
                }
              />
            </Grid>
            {showEditIcon && (
              <Grid>
                <EditIconSvg
                  height={'16px'}
                  width={'16px'}
                  onClick={() => {
                    setIsActive(true);
                  }}
                  cursor={'pointer'}
                />
              </Grid>
            )}
          </Grid>
          <Grid className={`${classes.section2}`}>
            {subTitle && (
              <Typography
                fontSize="12px"
                textColor={patientAccessTheme.palette.text.highemphasis}
              >
                {subTitle}
              </Typography>
            )}
            <Grid
              className={`${classes.sectionContainer} ${classes.section2Inner}`}
            >
              <Grid className={classes.controlsContainer}>
                <TextField
                  placeholder={'Search'}
                  height="36px"
                  width="232px"
                  endAdornment={
                    <SimpleSearch
                      height="20px"
                      width="20px"
                      stroke={patientAccessTheme.palette.text.lowemphasis}
                    />
                  }
                  value={searchText || ''}
                  onChange={onSearchChange}
                />
                <Button
                  label="Add Custom"
                  width="auto"
                  color="primary"
                  variant="outlined"
                  styleProps={{
                    fontSize: '12px',
                  }}
                  startIcon={<Add fill="#475CB0" />}
                  onClick={() => {
                    setIsAddCustom?.(true);
                  }}
                />
              </Grid>
              {isAddCustom && (
                <Grid className={classes.addCustomConatiner}>
                  <AddCustomParameter
                    cancelButtonLabel={'Discard'}
                    saveButtonLabel={'Add'}
                    onCancel={() => setIsAddCustom?.(false)}
                    onSave={(param) => {
                      setCustomParams?.((prev) => {
                        const nextId = (prev.length + 1).toString(); // next id as "1", "2", "3" ...
                        return [...prev, { id: nextId, ...param }];
                      });
                      setIsAddCustom?.(false);
                    }}
                  />
                </Grid>
              )}
              <Grid
                style={{
                  padding: '0px',
                }}
              >
                {subBody}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      }
    />
  );
};

export default AddNewAndSubParameter;
